import React from "react";
import CustomerInfo from "./customer-info";
import OrderShippingCard from "./orderShippingCard";
import StoreInfo from "./store-info";

const OrderShippingInfo = ({
  singleOrderDetails,
  onStatusUpdate,
  lastOrder,
}: any) => {
  return (
    <div
      style={{ display: "flex", flexDirection: "column", gap: "24px", flex: 1 }}
    >
      <OrderShippingCard
        order={singleOrderDetails}
        onStatusUpdate={onStatusUpdate}
      />
      <CustomerInfo order={singleOrderDetails} lastOrder={lastOrder} />
      <StoreInfo order={singleOrderDetails} />
    </div>
  );
};

export default OrderShippingInfo;
